/* eslint-disable @typescript-eslint/no-unused-vars */
import session, {
  SessionInteractor,
  Session,
  SessionState,
} from '@updater-core/interactors/shell/session';
import { useInteractorState } from '@updater-core/view/hooks/interactor';
import { useMemo } from 'react';

type SessionSelectors = SessionInteractor['selectors'];

/**
 * Generates derived state from session selectors
 */
function useDerivedSessionState(
  sessionState: SessionState,
  sessionSelectors: SessionSelectors
): Session {
  const derivedState = useMemo(
    () =>
      sessionSelectors.isAuthenticated(sessionState)
        ? (Object.entries(sessionSelectors).reduce(
            (acc, [stateKey, selector]) => ({
              ...acc,
              [stateKey]: selector(sessionState),
            }),
            {}
          ) as Session)
        : ({} as Session),
    [sessionState]
  );
  return derivedState;
}

/**
 * Reactive wrapper around session information. (user, move, steps, etc)
 */
export function useSession(): Session {
  const sessionState: SessionState = useInteractorState(session);
  const derivedState = useDerivedSessionState(sessionState, session.selectors);
  return derivedState;
}
